import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import {
  ActivatedRoute,
  ActivatedRouteSnapshot,
  Router,
} from '@angular/router';
import { AlertDialogService } from '../../../../services/alert-dialog.service';
import { CookieService } from 'ngx-cookie-service';
import { MissionService } from '../../../../services/mission.service';
import { EstablishmentService } from '../../../../services/establishment.service';
import {
  acceptationCandidantOptions,
  priorityMissionOptions,
  statusMissionOptions,
  typeContratOptions,
} from '../../../../shared/utils/data/etablissments-data';
import moment from 'moment';
import { FlagService } from '../../../../shared/services/flag.service';
import { FlagType } from '../../../../shared/utils/enums';
import { Site } from '../../../../models/Site';
import { debounceTime } from 'rxjs';
import { GenericCharge } from '../../../../models/GenericCharge';
import {
  displayImg,
  removeBlankAttributes,
} from '../../../../shared/utils/utils.functions';
import { parseRemuneration, remunerationValidator } from '../../../../shared/utils/remuneration.validator';
import { AuthService } from '../../../../services/auth.service';
import { ImageDialogComponent } from '../../../../shared/image-dialog/image-dialog.component';
import { MatDialog } from '@angular/material/dialog';

@Component({
  selector: 'app-add-mission',
  templateUrl: './add-mission.component.html',
  styleUrl: './add-mission.component.scss',
})
export class AddMissionComponent implements OnInit {
  imageUrls: string[] = [];
  id: number;
  errorMessageStartDate: string = '';
  errorMessageEndDate: string = '';
  formGroup: FormGroup = this.fb.group({
    etablissementId: ['', Validators.required],
    regionId: [0, Validators.required],
    adresseId: ['', Validators.required],
    missionTitle: [{ value: '', disabled: true }, Validators.required],
    // etatDefaut: ['', Validators.required],
    serviceAffectationId: [
      { value: <string | number>'', disabled: true },
      Validators.required,
    ],
    typeSecteurId: [<string | number>'', Validators.required],
    typePosteId: [
      { value: <string | number>'', disabled: true },
      Validators.required,
    ],
    fichePosteId: [''],
    typeposte: [''],
    anesthetistassistedbyanesthetistnurse: [false],
    region: [''],
    id: [''],
    isurgent: [''],
    serviceaffectation: [''],
    description: [
      '',
      [
        Validators.required,
        Validators.minLength(50),
        Validators.maxLength(1000),
      ],
    ],
    startdate: ['', Validators.required],
    starttime: ['', Validators.required],
    enddate: [{ value: '', disabled: true }, Validators.required],
    endtime: ['', Validators.required],
    compensationproposednet: [
      0,
      // Accept a comma decimal ("11,5"); min 50 (no per-hour mode on this form).
      [Validators.required, remunerationValidator()],
    ],
    typecontat: [''],
    platformManagedBy: [''],
    primeprovided: [1500],
    ismealsprovidedbyestablishment: [false],
    isaccommodationprovidedbyestablishment: [false],
    isprimeprovided: [false],
    isthirteenthmonthprovided: [false],
    istakinginchargetravelingexpenses: [false],
    childrenunderone: [false],
    childrenagedonetothree: [false],
    childrenagedthreetoten: [false],
    patientsinorlsurgery: [false],
    patientsincardiacsurgery: [false],
    patientsinneurocerebralsurgery: [false],
    accommodationconditions: [''],
    mealsconditions: [''],
    travelingconditions: [''],
    otherprimesconditions: [''],
    isaccommodationprovidedfromexterior: [false],
    ismealsprovidedfromexterior: [false],
    isotherprimeprovided: [false],
    photo1: '',
    photo2: '',
    photo3: '',
    photo4: '',
    photo5: '',
  });



  FraisPostList: GenericCharge[] = [
    {
      id: 1,
      type: 'checkbox',
      controlName: 'childrenunderone',
      label: "Enfants de moins d'un an",
      display: true,
      isSecond: false,
    },
    {
      id: 2,
      type: 'checkbox',
      controlName: 'childrenagedonetothree',
      label: 'Enfants agés de 1 à 3 ans',
      display: true,
      isSecond: false,
    },
    {
      id: 3,
      type: 'checkbox',
      controlName: 'childrenagedthreetoten',
      label: 'Enfants agés de 3 à 10 ans',
      display: true,
      isSecond: false,
    },
    {
      id: 4,
      type: 'checkbox',
      controlName: 'patientsinorlsurgery',
      label: 'Patients en chirurgie ORL',
      display: true,
      isSecond: false,
    },
    {
      id: 5,
      type: 'checkbox',
      controlName: 'patientsincardiacsurgery',
      label: 'Patients en chirurgie cardiaque',
      display: true,
      isSecond: false,
    },
    {
      id: 6,
      type: 'checkbox',
      controlName: 'patientsinneurocerebralsurgery',
      label: 'Patients en neurochirurgie cérébrale',
      display: true,
      isSecond: false,
    },
  ];

  ChargeList: GenericCharge[] = [
    {
      id: 1,
      type: 'checkbox',
      controlName: 'isaccommodationprovidedbyestablishment',
      label: 'Hébergement',
      display: true,
      isSecond: false,
    },
    {
      id: 3,
      type: 'radio',
      options: [
        { label: 'Au sein de l’établissement', value: false },
        { label: 'Extérieur (Hôtel ou location)', value: true },
      ],
      controlName: 'isaccommodationprovidedfromexterior',
      label: 'Prise en charge',
      display: false,
      isSecond: true,
    },
    {
      id: 2,
      type: 'textarea',
      controlName: 'accommodationconditions',
      label: 'Conditions de prise en charge',
      display: false,
      isSecond: true,
    },

    {
      id: 4,
      type: 'checkbox',
      controlName: 'ismealsprovidedbyestablishment',
      label: 'Repas',
      display: true,
      isSecond: false,
    },
    {
      id: 8,
      type: 'radio',
      options: [
        { label: 'Au sein de l’établissement', value: false },
        { label: 'Extérieur (restaurants et commerces)', value: true },
      ],
      controlName: 'ismealsprovidedfromexterior',
      label: 'Prise en charge',
      display: false,
      isSecond: true,
    },
    {
      id: 9,
      type: 'textarea',
      controlName: 'mealsconditions',
      label: 'Conditions de prise en charge',
      display: false,
      isSecond: true,
    },

    {
      id: 5,
      type: 'checkbox',
      controlName: 'istakinginchargetravelingexpenses',
      label: 'Frais de déplacement',
      display: true,
      isSecond: false,
    },
    {
      id: 10,
      type: 'textarea',
      controlName: 'travelingconditions',
      label: 'Conditions de prise en charge',
      display: false,
      isSecond: true,
    },

    {
      id: 6,
      type: 'checkbox',
      controlName: 'isprimeprovided',
      label: 'Prime d’installation',
      display: false,
      isSecond: false,
    },
    {
      id: 7,
      type: 'checkbox',
      controlName: 'isthirteenthmonthprovided',
      label: 'Treizième mois',
      display: false,
      isSecond: false,
    },

    {
      id: 11,
      type: 'checkbox',
      controlName: 'isotherprimeprovided',
      label:
        'Existe-t-il autres primes ou indemnités mensuelles ou annuelles en euros ? ',
      display: false,
      isSecond: false,
    },
    {
      id: 12,
      type: 'textarea',
      controlName: 'otherprimesconditions',
      label: 'Autres conditions',
      display: false,
      isSecond: true,
    },
  ];

  listUrls: any = {
    path: 'missions',
    label: 'Missions',
    url: '/dashboard/missions',
    children: [
      {
        path: 'add',
        label: 'Créer une mission',
        url: '/dashboard/missions/add',
      },
    ],
  };
  today = new Date();
  siteList: Site[] = [];
  affectationServiceList: any[] = [];
  fichePostesList: any[] = [];
  posteList: any[] = [];
  secteurList: any[] = [];
  loading = false;
  missionId: string;
  mission: any;
  constructor(
    private fb: FormBuilder,
    private router: Router,
    private alertDialogService: AlertDialogService,
    private dialog: MatDialog,
    private api: MissionService,
    private flag: FlagService,
    private route: ActivatedRoute,
    private establishmentService: EstablishmentService,
    private auth: AuthService,
  ) {
    try {
      this.id = this.auth.id??this.auth?.user?.collary_id??0
      this.formGroup.get('etablissementId')?.patchValue(this.id);
    } catch (error) {}
    this.missionId = this.route.snapshot.params['id'];
  }

  ngOnInit(): void {
    console.log("this.route.snapshot",this.route.snapshot);
    this.formGroup.get('fichePosteId')?.disable();
    // moment()
    this.formGroup
      .get('serviceAffectationId')
      ?.valueChanges.subscribe((res) => {
        this.fichePostesList = this.affectationServiceList
          .filter((el) => el.id == res)[0]
          ?.fichePostes?.map((el: any) => {
            return {
              id: el.id,
              label: el.name,
            };
          });
      });
    this.getRef();

    if (this.id) {
      this.getCurrentEstablishment();
      // this.getAffectations()
      this.getSecteurs();
      this.getSites();
      if (this.missionId) {
        this.getMissionById();
      }
    }
    this.formGroup.get('typecontat')?.valueChanges.subscribe((val) => {
      const installationIndex = this.ChargeList.findIndex((a) => a.id === 6);
      const thirdMonthIndex = this.ChargeList.findIndex((a) => a.id === 7);
      const otherIndex = this.ChargeList.findIndex((a) => a.id === 11);
      this.ChargeList[installationIndex].display =
        this.typeContract !== 'LIBERAL' && this.typeContract !== '';
      this.ChargeList[thirdMonthIndex].display =
        this.typeContract !== 'LIBERAL' && this.typeContract !== '';
      this.ChargeList[otherIndex].display =
        this.typeContract !== 'LIBERAL' && this.typeContract !== '';
    });

    this.formGroup.get('startdate')?.valueChanges.subscribe((val) => {
      const inSevenDays = moment(new Date())
        .add(8, 'days')
        .format('YYYY-MM-DD');
      const isUrgent = moment(val).isBefore(inSevenDays);
      this.formGroup.get('isurgent')?.patchValue(isUrgent);

      if (isUrgent) {
        this.formGroup.get('isurgent')?.disable();
      } else {
        this.formGroup.get('isurgent')?.enable();
      }
    });

    this.formGroup.get('startdate')?.valueChanges.subscribe((res) => {
      if (res) {
        if (this.formGroup.get('enddate')?.disabled) {
          this.formGroup.get('enddate')?.enable();
        }
      } else {
        if (this.formGroup.get('enddate')?.enabled) {
          this.formGroup.get('enddate')?.disable();
          this.formGroup.get('enddate')?.patchValue('');
        }
      }
    });

    this.formGroup.get('typePosteId')?.valueChanges.subscribe((value) => {
      if (value) {
        const poste = this.posteList.find((p) => p.value === value);
        if (poste) {
          this.formGroup.get('typeposte')?.patchValue(poste.label);
          if (value === 3) {
        this.formGroup.get('anesthetistassistedbyanesthetistnurse')?.patchValue(true);
      } else {
        this.formGroup.get('anesthetistassistedbyanesthetistnurse')?.patchValue(false);
      }
        }
      }
    });

    this.formGroup.get('regionId')?.valueChanges.subscribe((value) => {
      if (value) {
        this.api.getRegionByCode(value).subscribe({
          next: (region) => {
            this.formGroup.get('region')?.patchValue(region.name);
          },
          error: () => {},
        });
      }
    });

    this.formGroup.get('parCollary')?.valueChanges.subscribe((value) => {
      if (value) {
        this.formGroup.get('parVousMeme')?.patchValue(!value);
      }
    });
    this.formGroup.get('parVousMeme')?.valueChanges.subscribe((value) => {
      if (value) {
        this.formGroup.get('parCollary')?.patchValue(!value);
      }
    });
    this.formGroup
      .get('serviceAffectationId')
      ?.valueChanges.subscribe((value) => {
        if (value) {
          this.formGroup.get('fichePosteId')?.enable();
        }
      });
    this.formGroup.get('typeSecteurId')?.valueChanges.subscribe((id) => {
      if (this.secteurList.find((s) => s.value === id)) {
        const secteurName = this.secteurList.find((s) => s.value === id).label;
        this.formGroup.get('serviceaffectation')?.patchValue(secteurName);
        this.getPostes(id);
      }
    });
    this.formGroup.get('adresseId')?.valueChanges.subscribe((id) => {
      const regionId: number = +this.siteList.find((s: Site) => s.id === id)
        ?.regionCode!;
      this.formGroup.get('regionId')?.patchValue(+regionId);
      this.getAffectations(id);
      if (!id) {
        if (this.formGroup.get('serviceAffectationId')?.enabled) {
          this.formGroup.get('serviceAffectationId')?.disable();
        }
      }
    });

    this.formGroup
      .get('isaccommodationprovidedbyestablishment')
      ?.valueChanges.subscribe((val) => {
        const conditionIndex = this.ChargeList.findIndex((a) => a.id === 2);
        const chargeIndex = this.ChargeList.findIndex((a) => a.id === 3);
        this.ChargeList[conditionIndex].display = val;
        this.ChargeList[chargeIndex].display = val;
      });

    this.formGroup
      .get('ismealsprovidedbyestablishment')
      ?.valueChanges.subscribe((val) => {
        const conditionIndex = this.ChargeList.findIndex((a) => a.id === 8);
        const chargeIndex = this.ChargeList.findIndex((a) => a.id === 9);
        this.ChargeList[conditionIndex].display = val;
        this.ChargeList[chargeIndex].display = val;
      });

    // traveling
    this.formGroup
      .get('istakinginchargetravelingexpenses')
      ?.valueChanges.subscribe((val) => {
        const conditionIndex = this.ChargeList.findIndex((a) => a.id === 10);
        this.ChargeList[conditionIndex].display = val;
      });

    // other
    this.formGroup
      .get('isotherprimeprovided')
      ?.valueChanges.subscribe((val) => {
        const conditionIndex = this.ChargeList.findIndex((a) => a.id === 12);
        this.ChargeList[conditionIndex].display = val;
      });

    // serviceAffectationId change
    this.formGroup
      .get('serviceAffectationId')
      ?.valueChanges.subscribe(async (val) => {
        this.imageUrls = [];
        if (val) {
          const serviceAffectation = await this.affectationServiceList.find(
            (a) => a.id === val
          );

          if (serviceAffectation && serviceAffectation.firstServicePhoto) {
            this.imageUrls.push(serviceAffectation.firstServicePhoto);
          }
          if (serviceAffectation && serviceAffectation.secondServicePhoto) {
            this.imageUrls.push(serviceAffectation.secondServicePhoto);
          }
        }
      });
  }

  getMissionById() {
    this.api.getMissionById(this.missionId).subscribe({
      next: (value) => {
        this.mission = value;
        this.formGroup.patchValue(this.mission);
      },
    });
  }

  get startDate(): Date {
    return new Date(this.formGroup.get('startdate')?.value);
  }
  get typeContract(): string {
    return this.formGroup.get('typecontat')?.value;
  }

  addMission() {
    this.alertDialogService
      ?.openAlertModal(
        'success',
        "Publication d'une mission",
        'Êtes-vous sûr(e) de vouloir publier cette mission ?',
        'Oui',
        'Non',
        '700px',
        true
      )
      ?.subscribe((res) => {
        if (res) {
          const body = this.formGroup.getRawValue();
          const parsedComp = parseRemuneration(body.compensationproposednet);
          if (!isNaN(parsedComp)) {
            body.compensationproposednet = parsedComp;
          }
          body.startdate = moment(body.startdate).add(1, 'hours').format('yyyy-MM-DDT00:00:00');
          body.enddate = moment(body.enddate).add(1, 'hours').format('yyyy-MM-DDT00:00:00');
          this.loading = true;
          const apiKey: string = this.mission
            ? 'updateDraftPublishMission'
            : 'addMission';

          this.api[this.mission ? 'updateDraftPublishMission' : 'addMission'](
            body
          ).subscribe({
            next: () => {
              this.flag.displayFlag(
                'Mission ajoutée avec succès !',
                FlagType.success
              );
              this.router.navigate(['/dashboard/missions']);
              this.loading = false;
            },
            error: () => {
              this.flag.displayFlag(
                'Veuillez compléter les informations manquantes.',
                FlagType.error
              );
              this.loading = false;
            },
          });
        }
      });
  }

  draftMission() {
    const body = this.formGroup.getRawValue();
    if (body.startdate == '') {
      this.errorMessageStartDate =
        'Pour enregistrer un brouillon, vous devez saisir la date du début de la mission.';
    }
    if (body.enddate == '') {
      this.errorMessageEndDate =
        'Pour enregistrer un brouillon, vous devez saisir la date du fin de la mission.';
    }
    if (body.startdate && body.enddate) {
      body.establishmentId = body.etablissementId;
      const parsedComp = parseRemuneration(body.compensationproposednet);
      if (!isNaN(parsedComp)) {
        body.compensationproposednet = parsedComp;
      }
      if (body.startdate) {

          body.startdate = moment(body.startdate).add(1, 'hours').format('yyyy-MM-DDT00:00:00');
      }

      if (body.enddate) {
          body.enddate = moment(body.enddate).add(1, 'hours').format('yyyy-MM-DDT00:00:00');
      }
      this.loading = true;
      this.api[this.mission ? 'updateDraftMission' : 'draftMission'](
        removeBlankAttributes(body)
      ).subscribe({
        next: () => {
          this.flag.displayFlag(
            'Mission ajoutée avec succès !',
            FlagType.success
          );
          this.router.navigate(['/dashboard/missions']);
          this.loading = false;
        },
        error: () => {
          this.flag.displayFlag(
            'Veuillez compléter les informations manquantes.',
            FlagType.error
          );
          this.loading = false;
        },
      });
    }
  }

  getAffectations(id: number) {
    this.api.getAffectationBySiteId(id).subscribe({
      next: (res) => {
        if (this.formGroup.get('serviceAffectationId')?.disabled) {
          this.formGroup.get('serviceAffectationId')?.enable();
        }
        // Only offer visible services in the dropdown (hide isvisible === false).
        this.affectationServiceList = (res || []).filter((s: any) => s.isvisible !== false);
        if (this.mission) {
          this.formGroup
            .get('serviceAffectationId')
            ?.patchValue(this.mission?.serviceAffectationId);
        }
      },
    });
  }

  getPostes(id: number) {
    this.formGroup.get('typePosteId')?.patchValue('');
    this.api.getPostes(id).then((res) => {
      if (res.length > 0) {
        this.formGroup.get('typePosteId')?.enable();
        this.posteList = res.map((p: any) => {
          return {
            value: p.id,
            label: p.name,
          };
        });
      } else {
      }
    });
  }

  getSecteurs() {
    this.api.getSecteurs().then((res) => {
      this.secteurList = res.map((s: any) => {
        return {
          value: s.id,
          label: s.name,
        };
      });
    });
  }

  getImage(images: any[]): void {
    for (let index = 0; index < 5; index++) {
      this.formGroup.get(`photo${index + 1}`)?.patchValue(images[index] || '');
    }
    // images.forEach((img, index) => {
    //   this.formGroup.get(`photo${index + 1}`)?.patchValue(img);
    // })
  }

  getRef() {
    this.api.getRefMission(this.id).subscribe({
      next: (ref) => {
        this.formGroup.get('missionTitle')?.patchValue(ref);
      },
    });
  }

  getSites() {
    this.establishmentService
      .getSiteByEstablishmentId(this.id, true)
      .subscribe({
        next: (value) => {
          //getSiteByEstablishmentId
          this.siteList = value.map((item: any) => {
            return {
              ...item,
              value: item.id,
              label: item.name,
            };
          });
        },
      });
  }

  getCurrentEstablishment() {
    this.establishmentService.getEstablishmentById(this.id).subscribe({
      next: (res) => {
        // this.siteList = res.adresses.map((item: any) => {
        //     return {
        //       value: item.id,
        //       label: item.name,
        //     }
        // })
      },
      error: (err) => {},
    });
  }

  goBack(): void {
    this.alertDialogService
      ?.openAlertModal(
        'success',
        'Quitter sans sauvegarder ?',
        'Vous avez saisi les informations pour créer une nouvelle mission, ' +
          'mais vous vous apprêtez à quitter la page sans sauvegarder. ' +
          'Toutes les modifications seront perdues. Êtes-vous sûr(e) de vouloir quitter sans sauvegarder ?',
        'Quitter sans Sauvegarder',
        'Revenir à la création',
        '700px',
        true
      )
      ?.subscribe((res) => {
        if (res) {
          this.router.navigateByUrl('/dashboard/missions');
        }
      });
  }

  checkBoxChange(e: any, value: string) {
    this.formGroup.get('platformManagedBy')?.patchValue(value);
  }

  openImage(img: any) {
    const dialog = this.dialog.open(ImageDialogComponent, {
      backdropClass: 'bg-transparent',

      data: img,
    });
    dialog.afterClosed().subscribe((value) => {
      if (value) {
      }
    });
  }

  protected readonly statusMissionOptions = statusMissionOptions;
  protected readonly priorityMissionOptions = priorityMissionOptions;
  protected readonly acceptationCandidantOptions = acceptationCandidantOptions;
  protected readonly typeContratOptions = typeContratOptions;
  protected readonly displayImg = displayImg;
}
